/**
 * Session and Inactivity configuration constants.
 */

// Log out after 15 minutes without any activity (HIPAA automatic logoff).
export const SESSION_TIMEOUT_MS = 15 * 60 * 1000;

// While the user is active, refresh at least this often (access tokens live 5 minutes and are
// also refreshed when less than 60 seconds remain). Refreshing keeps the server session alive.
export const PROACTIVE_REFRESH_THRESHOLD_MS = 4 * 60 * 1000;

// Throttle activity tracking to once every 2 seconds
export const ACTIVITY_THROTTLE_MS = 2000;

// Interval to check session status
export const SESSION_CHECK_INTERVAL_MS = 10 * 1000;
